<template>
  <div>
      <div class="Loc MobileHide">
       <div>
           <div class="row" style="margin-top: 70px;">
            <div class="col" style="text-align: center; margin-top: 15%;">
              <img style="width: 110px;" :src="teamLogo + id"/>
              <p style="color: white;">{{name}}</p>
              <b-btn v-if="favs.some(fav => fav.id === id)" v-on:click="removeFavorite({value: id , type: team})" style="margin-top: 5px; background: none; width: 5px; height: 5px; border: none;"> <img :src="favImage1" style="width: 15px; margin-top: -30px; margin-left: -10px;" alt="">  </b-btn>
              <b-btn v-else v-on:click="addToFavorites({value: id , type: team})" style="margin-top: 5px; background: none; width: 5px; height: 5px; border: none;"> <img :src="favImage" style="width: 15px; margin-top: -30px; margin-left: -10px;" alt="">  </b-btn>
            </div>
            </div>
          </div>
      </div> 
      <div class="Loc MobileShow container" style="height: 240px;">
       <div>
           <div class="row" style="margin-top: 70px;">
            <div class="col" style="text-align: center; margin-top: 15%;">
              <img style="width: 110px;" :src="teamLogo + id"/>
              <p style="color: white;">{{name}}</p>
              <b-btn v-if="favs.some(fav => fav.id === id)" v-on:click="removeFavorite({value: id , type: team})" style="margin-top: -20px; background: none; width: 5px; height: 5px; border: none;"> <img :src="favImage1" style="width: 15px; margin-top: -30px; margin-left: -10px;" alt="">  </b-btn>
              <b-btn v-else v-on:click="addToFavorites({value: id , type: team})" style="margin-top: -20px; background: none; width: 5px; height: 5px; border: none;"> <img :src="favImage" style="width: 15px; margin-top: -30px; margin-left: -10px;" alt="">  </b-btn>
            </div>
            </div>
          </div>
      </div> 
        <div>
       <div v-for="game in gamesHistory" :key="game.id">
            <ul class="list-group Info MobileHide" style="border-radius: 0px;">
            <li class="list-group-item listHeader" style="text-align: end;">{{game.matchTime.slice(0,-9)}}</li>
            <router-link id="router-link" :to="{ name: 'MatchPagePar', params: { gameId: game.id } }"> <li class="list-group-item infoItem">
                <div class="row">
                    <div class="col">
                    <div class="circle" style="display:flex;justify-content:center;align-items:center; background: white;">
                       <img :src="tournamentLogo + game.tournament.id" alt="" style="width: 23px;" >
                    </div>
                </div>
                    <div class="col-8" >
                        <p>{{game.team1.name}} </p>
                        <p>{{game.team2.name}} </p>
                    </div>
                    <div class="col-1">
                       <p>{{game.currentScore.slice(0,1)}}</p>
                       <p>{{game.currentScore.slice(-1)}}</p>
                    </div>
                     <div class="col" style="display:flex;justify-content:center;align-items:center;">
                        <div class="circle" style="background: green;" v-if="game.winner == 1 && game.team1.id == id || game.winner == 2 && game.team2.id == id">
                          <p style="text-align: center; padding-top: 40%;">{{game.matchStatus.name}}</p> 
                        </div> 
                        <div class="circle" style="background: grey;" v-else-if="game.winner == 0 && (game.matchStatus.name != 'POSTP' && game.matchStatus.name != 'NS' && game.matchStatus.name != 'CANCL') "> 
                          <p style="text-align: center; padding-top: 40%;" v-if="game.matchStatus.name == 'FT_PEN'">FT</p> 
                          <p style="text-align: center; padding-top: 40%;" v-else>{{game.matchStatus.name}}</p> 
                        </div>
                        <div class="circle" style="background: #990000;" v-else-if="game.winner == 1 && game.team2.id == id || game.winner == 2 && game.team1.id == id"> 
                          <p style="text-align: center; padding-top: 40%;">{{game.matchStatus.name}}</p> 
                        </div>
                         <div class="circle" v-else> 
                          <p style="text-align: center; padding-top: 40%;" v-if="game.matchStatus.name == 'POSTP'">PST</p> 
                          <p style="text-align: center; padding-top: 40%;" v-else-if="game.matchStatus.name == 'CANCL'">CAN</p> 
                          <p style="text-align: center; padding-top: 40%;" v-else-if="game.matchStatus.name == 'FT_PEN'">FT</p> 
                          <p style="text-align: center; padding-top: 40%;" v-else>{{game.matchStatus.name}}</p> 
                        </div>
                     </div>
                    </div>  
                </li> </router-link>
             </ul>
             <ul class="list-group Info MobileShow" style="border-radius: 0px;">
            <li class="list-group-item listHeader" style="text-align: end;">{{game.matchTime.slice(0,-9)}}</li>
            <router-link id="router-link" :to="{ name: 'MatchPagePar', params: { gameId: game.id } }"> <li class="list-group-item infoItem">
                <div class="row">
                    <div class="col">
                     <div class="circle" style="display:flex;justify-content:center;align-items:center; background: white;">
                       <img :src="tournamentLogo + game.tournament.id" alt="" style="width: 23px;" >
                    </div>
                </div>
                    <div class="col-7">
                        <p v-if="game.team1.name.length > 16">{{game.team1.name.slice(0,15)}}.. </p><p v-else>{{game.team1.name}} </p>
                        <p v-if="game.team2.name.length > 16">{{game.team2.name.slice(0,15)}}.. </p><p v-else>{{game.team2.name}} </p>
                    </div>
                    <div class="col-1">
                       <p>{{game.currentScore.slice(0,1)}}</p>
                       <p>{{game.currentScore.slice(-1)}}</p>
                    </div>
                     <div class="col">
                        <div class="circle" style="background: green;" v-if="game.winner == 1 && game.team1.id == id || game.winner == 2 && game.team2.id == id">
                          <p style="text-align: center; padding-top: 40%;">{{game.matchStatus.name}}</p> 
                        </div> 
                        <div class="circle" style="background: grey;" v-else-if="game.winner == 0 && (game.matchStatus.name != 'POSTP' && game.matchStatus.name != 'NS' && game.matchStatus.name != 'CANCL') "> 
                          <p style="text-align: center; padding-top: 40%;" v-if="game.matchStatus.name == 'FT_PEN'">FT</p> 
                          <p style="text-align: center; padding-top: 40%;" v-else>{{game.matchStatus.name}}</p> 
                        </div>
                        <div class="circle" style="background: #990000;" v-else-if="game.winner == 1 && game.team2.id == id || game.winner == 2 && game.team1.id == id"> 
                          <p style="text-align: center; padding-top: 40%;">{{game.matchStatus.name}}</p> 
                        </div>
                         <div class="circle" v-else> 
                          <p style="text-align: center; padding-top: 40%;" v-if="game.matchStatus.name == 'POSTP'">PST</p> 
                          <p style="text-align: center; padding-top: 40%;" v-else-if="game.matchStatus.name == 'CANCL'">CAN</p> 
                          <p style="text-align: center; padding-top: 40%;" v-else-if="game.matchStatus.name == 'FT_PEN'">FT</p> 
                          <p style="text-align: center; padding-top: 40%;" v-else>{{game.matchStatus.name}}</p> 
                        </div>
                     </div>
                    </div>  
                </li> </router-link>
             </ul>    
       </div>
          </div>
  </div> 
  
</template>

<script>
import {mapGetters, mapActions} from 'vuex';

export default {
  name: 'teamPage',
  data(){
      return{
        gamesHistory: [],
        id: '',
        teamLogo: 'https://sportapi.zuniac.com/team/logo/',
        tournamentLogo: 'https://sportapi.zuniac.com/tournament/logo/',
        name: '',
        cookiesObject: '',
        showDismissibleAlert: false,  
        favImage: require('@/assets/favorite1.png'),
        favImage1: require('@/assets/favoriteGreen.png'),
        team: "team",
        }
  },
  async mounted(){
    this.id = this.$route.params.id;

   
    var cookiesObject = document.cookie.split(';').map(cookie => cookie.split('=')).reduce((accumulator, [key, value]) => ({...accumulator, [key.trim()]: decodeURIComponent(value)}),{});
    this.cookiesObject = cookiesObject;

    var offset = new Date().getTimezoneOffset();

    if (cookiesObject.token) {
    var res = await fetch(this.httpReq + '/team/matches?langId='+ this.cookiesObject.langId  +'&portalId=' + cookiesObject.portalId + '&teamId=' + this.id + '&timezone=%2B'+ offset/-60 +'%3A00&token=' + cookiesObject.token );
    var data = await res.json();
    var gamesHistory = data.matches;
    this.gamesHistory = gamesHistory;
    this.name = data.team.name;

    if (data.code == 200) {
       //everything is okay
    }
    else if (data.code == 401) {
      alert('Logged from another browser, try to re sign!');
         document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1";
        document.cookie = "lang = en";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        location.assign("/");
    } else if(data.code == 404){
        alert('Token is not valid and portal id not provided')
        document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1";
        document.cookie = "lang = en";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        location.assign("/");
    }
    else if(data.code == 500){
        alert('Server side error')
        document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1";
        document.cookie = "lang = en";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        location.assign("/");
    } else {
        alert('service error')
        document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1";
        document.cookie = "lang = en";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        location.assign("/");
    }
      
    } else {
    var resp = await fetch(this.httpReq + '/team/matches?langId='+ this.cookiesObject.langId  +'&portalId=' + cookiesObject.portalId + '&teamId=' + this.id + '&timezone=%2B'+ offset/-60 +'%3A00');
    var datas = await resp.json();
    var gamesHistorys = datas.matches;
    this.gamesHistory = gamesHistorys;
    this.name = data.team.name;
    }

  },

  

  components: {
  },
  props: {},
  methods : {
      ...mapActions(["removeFavorite", "addToFavorites"]),
    
  },
  
  computed: {
      ...mapGetters(["favs", 'httpReq']),
  },
}

</script>

<style scoped>
.Loc{
    background:linear-gradient(
          rgba(0, 0, 0, 0.5), 
          rgba(0, 0, 0, 0.5)
        ),  url('./soccerCover.jpg');
    background-size: cover;
    width: 100%;
    height: 300px;
    margin-top: -70px;
}


.leagueNam{
    text-align:center; 
    padding-top: 70px;
    font-size: 18px;
    color: white;
}


/* Navbar (info, H2H, etc.) */


.navDiv2{
    width: 100%;
    height: 60px;
    color: white;
    background-image: linear-gradient(#fefefe , #c3c3c3);  
}

#topheader2 .navbar-nav li > a {
	text-transform: capitalize;
    transition: background-color 0.2s, color 0.2s;
}

    #topheader2 .navbar-nav li > a:focus {
        background-image: linear-gradient(#39b44a , #39b54a);
        color: #fff !important;
	}

#topheader2 .navbar-nav li.active > a {
	background-color: #333;
	color: #fff;
}

#routerLink{
  padding-top: 10%;
    display: inline-block; 
    text-decoration: none;
    width: 111px !important;
    height: 60px !important;
    color: black !important;
    text-align: center !important;
    margin-top: -8px;
}
#routerLink .navbar-nav li > a {
	text-transform: capitalize;
	transition: background-color 0.2s, color 0.2s;
    
}

    #routerLink .navbar-nav li > a:focus {
        background-image: linear-gradient(#39b44a , #1b5f20);
		color: #fff !important;
	}

#routerLink .navbar-nav li.active > a {
	background-color: #333;
	color: #fff;
}
.list-group-item{
    line-height: 5px;
}

.listHeader{
  background-color: #333333 !important;  
  color: white;
  text-align: center;
  font-weight: 400;
  font-size: 15px;
}

.infoItem{
background-color: #4d4d4d !important;
color: white;
border-color: #333333 !important;
border-width: 1px !important;
height: 60px;
border-radius: 0px;
}

.circle {
    background: #333333;
    width: 40px;
    height: 40px;
    border-radius: 50%;
}

.Draw {
    background: #dc2426;
}
 #router-link, #router-link:visited, #router-link:active, #router-link:focus{
    text-decoration: none;
    border: 0;
    outline: 0;
  }
  @media only screen and (max-width: 770px) {
  body{
    background: #212529;
  }
  .navDiv2{
    width: 100%;
    height: 60px;
    color: white;
    background: #1b1d20;  
}
  .MobileHide {
    display: none;
  }
}

@media only screen and (min-width: 770px) {
  .MobileShow {
    display: none;
  }

}
</style>
